import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import translations from './.vocab';
import type { DisplayRecommendation, TaxCode } from './types';
import { createTaxSuffixString } from './utils/createTaxSuffixString';

interface TaxSuffixProps extends ComponentProps<typeof Text> {
  taxCode: TaxCode;
  displayRecommendation: DisplayRecommendation;
  locale: Locale;
}

export const TaxSuffix = ({
  taxCode,
  displayRecommendation,
  ...textProps
}: TaxSuffixProps) => {
  const { t } = useTranslations(translations);

  const taxSuffixString = createTaxSuffixString(
    displayRecommendation,
    taxCode,
    t('tax-suffix-inclusive'),
    t('tax-suffix-exclusive'),
  );

  return <Text {...textProps}>{taxSuffixString}</Text>;
};
